import React from "react";
import { product } from "../data/product";
import { Bonuses } from "../components/Bonuses";
import { BundleOffer } from "../components/BundleOffer";
import { Collections } from "../components/Collections";
import { Comparison } from "../components/Comparison";
import { FaqSection } from "../components/FaqSection";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { InsideRecipe } from "../components/InsideRecipe";
import { Marquee } from "../components/Marquee";
import { Reviews } from "../components/Reviews";
import { Steps } from "../components/Steps";
import { Accent } from "../components/ui/SectionHeading";
export function Landing() {
  return <div lang="it" className="min-h-screen w-full bg-cream font-sans text-ink [hyphens:manual]" data-id="element-198" data-mp="cbibxrhoo8jd">
      <Header data-id="element-199" data-mp="h6e730i7vc0p" />
      <main data-id="element-200" data-mp="m7le2xcjc76b">
        <Marquee data-id="element-201" data-mp="m7bxu1haledt" />
        <Hero data-id="element-202" data-mp="m6shuqb7d02f" />
        <Comparison data-id="element-203" data-mp="m8da29a1o6x4" />
        <Reviews data-id="element-204" data-mp="m7v4gm1hsgcj" />
        <BundleOffer id="acquista" withGallery title={<>
              Tutto quello che ti serve, <Accent data-id="element-206" data-mp="3tftk4syz6kkc">in un unico pacchetto</Accent>
            </>} subtitle="Dai burri corpo agli scrub, dagli oli in poi: reso semplice per iniziare oggi stesso." data-id="element-205" data-mp="m58xoomfe4vd" />
        <InsideRecipe data-id="element-207" data-mp="3kg6kocpt3otx" />
        <Collections data-id="element-208" data-mp="3kgoopvipn7ce" />
        <Bonuses data-id="element-209" data-mp="3khhnoabfgsjz" />
        <Steps data-id="element-210" data-mp="3khzsvwg2ih41" />
        <FaqSection data-id="element-211" data-mp="l0i8fz5dgvmt" />
        <BundleOffer id="bundle" title={<>
              Da acquirente <Accent data-id="element-213" data-mp="gyeoem4n0ipx">a creatrice</Accent>
            </>} subtitle={`${product.recipes} ricette che trasformano la tua cucina nell'unico scaffale di bellezza di cui hai bisogno.`} data-id="element-212" data-mp="l0rr11o380ih" />
      </main>
      <Footer data-id="element-214" data-mp="7826l1o7j3nh" />
    </div>;
}